import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { hideSnackbar } from '../actions/snackbar';
import Snackbar from '../components/Snackbar';

class SnackbarMessage extends Component {
    render () {
        return (
            <Snackbar
                message={this.props.message}
                open={this.props.open}
                onClose={this.props.onClose}/>
        );
    }
}

SnackbarMessage.propTypes = {
    message: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

const stateToProps = (state) => {
    return {
        open: state.snackbar.open,
        message: state.snackbar.message,
    };
};

const actionsToProps = {
    onClose: hideSnackbar,
};

export default connect(stateToProps, actionsToProps)(SnackbarMessage);
